"use client";

import { usePlayer } from "@/context/player-context";
import { Content } from "@/services/content/types";
import classNames from "classnames";
import Icon from "./icon";

type PodcastPlayButtonType = {
  podcast: Content.PodcastEpisode;
  small?: boolean;
};

const PodcastPlayButton = ({ podcast, small }: PodcastPlayButtonType) => {
  const { podcast: playingPodcast, openPodcast, closePodcast } = usePlayer();

  const isActive = playingPodcast && playingPodcast?.sys.id == podcast?.sys?.id;
  return (
    <>
      <button
        className={classNames(
          "ignore-group-hover flex items-center mt-2 hover:underline",
          small ? "text-md" : "text-lg"
        )}
        onClick={(e) => {
          e.preventDefault();
          isActive ? closePodcast() : openPodcast(podcast);
        }}
      >
        {isActive ? (
          <Icon.PauseInverted
            bgClassName="fill-blue-500"
            className={classNames(
              "fill-white-500",
              small ? "w-4 h-4 mr-1" : " w-7 h-7 mr-2"
            )}
          />
        ) : (
          <Icon.PlayInverted
            bgClassName="fill-blue-500"
            className={classNames(
              "fill-white-500",
              small ? "w-4 h-4 mr-1" : " w-7 h-7 mr-2"
            )}
          />
        )}
        {isActive ? (
          <span className="font-bold ">Lyssnar...</span>
        ) : (
          <span className="font-bold ">Lyssna</span>
        )}
      </button>
    </>
  );
};

export default PodcastPlayButton;
